// extracted by mini-css-extract-plugin
module.exports = {"plexBalance":"PlexBalance_plexBalance__Fi7GC","icon":"PlexBalance_icon__aOCw8","text":"PlexBalance_text__2QcKL"};